module.exports = __webpack_public_path__ + "img/jiGuang6.ac45fc41.png";